import "@/App.css";
import { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { servicePath } from "@/lib/paths";

function LegacyServiceRedirect() {
  const { slug, capability } = useParams();
  return <Navigate to={servicePath(slug, capability)} replace />;
}
function LegacyApproachRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/aboutus/${slug}`} replace />;
}
import { Toaster } from "sonner";
import { CookieConsent } from "@/components/CookieConsent";
import { BookmarkVisitTracker } from "@/components/BookmarkVisitTracker";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
const MarketPricesPage = lazy(() => import("@/pages/MarketPricesPage"));
const LinkGate = lazy(() => import("@/pages/LinkGate"));
const AuditPage = lazy(() => import("@/pages/AuditPage"));
const HowWeSavePage = lazy(() => import("@/pages/HowWeSavePage"));
const LifePage = lazy(() => import("@/pages/LifePage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const GalleryPage = lazy(() => import("@/pages/GalleryPage"));
const Login = lazy(() => import("@/pages/Login"));
const Admin = lazy(() => import("@/pages/Admin"));
const SystemDocsPage = lazy(() => import("@/pages/SystemDocsPage"));
const AuthCallback = lazy(() => import("@/pages/AuthCallback"));
const BessSizing = lazy(() => import("@/pages/BessSizing"));
const SharedCompare = lazy(() => import("@/pages/SharedCompare"));
const VendorQuotePage = lazy(() => import("@/pages/VendorQuotePage"));
const VendorClarifyPage = lazy(() => import("@/pages/VendorClarifyPage"));
const VerifyWhatsAppPage = lazy(() => import("@/pages/VerifyWhatsAppPage"));
const VaultUploadPage = lazy(() => import("@/pages/VaultUploadPage"));
const BrokerQuotePage = lazy(() => import("@/pages/BrokerQuotePage"));
const MatrixSignoffPage = lazy(() => import("@/pages/MatrixSignoffPage"));
const ExitSurveyPage = lazy(() => import("@/pages/ExitSurveyPage"));
const VendorHubPage = lazy(() => import("@/pages/VendorHubPage"));
const SupplierPortalPage = lazy(() => import("@/pages/SupplierPortalPage"));
const AgreementReviewPage = lazy(() => import("@/pages/AgreementReviewPage"));
const AgreementSignPage = lazy(() => import("@/pages/AgreementSignPage"));
const MarketPulsePage = lazy(() => import("@/pages/MarketPulsePage"));
const SolutionPage = lazy(() => import("@/pages/SolutionPage"));
const AlertsManagePage = lazy(() => import("@/pages/AlertsManagePage"));
const IndustryIntelPage = lazy(() => import("@/pages/IndustryIntelPage"));
const OemProfilePage = lazy(() => import("@/pages/OemProfilePage"));
const ServicePage = lazy(() => import("@/pages/ServicePage"));
const AdvisoryCapabilityPage = lazy(() => import("@/pages/CapabilityPage"));
const Tenders = lazy(() => import("@/pages/Tenders"));
const ApproachPage = lazy(() => import("@/pages/ApproachPage"));
const ApproachIndex = lazy(() => import("@/pages/ApproachIndex"));
const ServicesIndex = lazy(() => import("@/pages/ServicesIndex"));
const NewsPage = lazy(() => import("@/pages/NewsPage"));
const EventsPage = lazy(() => import("@/pages/EventsPage"));
const CaseStudiesPage = lazy(() => import("@/pages/CaseStudiesPage"));
const TeamPage = lazy(() => import("@/pages/TeamPage"));
const ImpactPage = lazy(() => import("@/pages/ImpactPage"));
const FaqPage = lazy(() => import("@/pages/FaqPage"));
const EbooksPage = lazy(() => import("@/pages/EbooksPage"));
const InsightsPage = lazy(() => import("@/pages/InsightsPage"));
const DigestArchivePage = lazy(() => import("@/pages/DigestArchivePage"));
const ArchivePage = lazy(() => import("@/pages/ArchivePage"));
const TopicPage = lazy(() => import("@/pages/TopicPage"));
const InsightPost = lazy(() => import("@/pages/InsightPost"));
const TeamPortal = lazy(() => import("@/pages/TeamPortal"));
const TenderPage = lazy(() => import("@/pages/TenderPage"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const SecurityPage = lazy(() => import("@/pages/SecurityPage"));
const ServicePageHi = lazy(() => import("@/pages/ServicePageHi"));
const TermsPage = lazy(() => import("@/pages/TermsPage"));
const SitemapPage = lazy(() => import("@/pages/SitemapPage"));
const TenderDetail = lazy(() => import("@/pages/TenderDetail"));
const StatePppPage = lazy(() => import("@/pages/StatePppPage"));
const RealEstatePage = lazy(() => import("@/pages/RealEstatePage"));
const RealEstateCityPage = lazy(() => import("@/pages/RealEstateCityPage"));
const PppIntelPage = lazy(() => import("@/pages/PppIntelPage"));
const InfraIntelPage = lazy(() => import("@/pages/InfraIntelPage"));
const RegulatoryNavigatorPage = lazy(() => import("@/pages/RegulatoryNavigatorPage"));
const SaasSuitePage = lazy(() => import("@/pages/SaasSuitePage"));
const NexusModulePage = lazy(() => import("@/pages/NexusModulePage"));
const EnergyGridMapPage = lazy(() => import("@/pages/EnergyGridMapPage"));
const TransmissionIntelPage = lazy(() => import("@/pages/TransmissionIntelPage"));
const TariffsPage = lazy(() => import("@/pages/TariffsPage"));
const ModScedPage = lazy(() => import("@/pages/ModScedPage"));
const AuctionTariffsPage = lazy(() => import("@/pages/AuctionTariffsPage"));
const MarketsKusumPage = lazy(() => import("@/pages/MarketsKusumPage"));
const MarketsSolarPumpsPage = lazy(() => import("@/pages/MarketsSolarPumpsPage"));
const MarketsRpoPage = lazy(() => import("@/pages/MarketsRpoPage"));
const TariffOrdersPage = lazy(() => import("@/pages/TariffOrdersPage"));
const EAuctionBidPage = lazy(() => import("@/pages/EAuctionBidPage"));
const ApproachStepPage = lazy(() => import("@/pages/ApproachStepPage"));
const PodcastPage = lazy(() => import("@/pages/PodcastPage"));
const LandmarkLessonPage = lazy(() => import("@/pages/LandmarkLessonPage"));
const NmpPage = lazy(() => import("@/pages/NmpPage"));
const NmpCaseStudyPage = lazy(() => import("@/pages/NmpCaseStudyPage"));
const StatePage = lazy(() => import("@/pages/StatePage"));
const ClientView = lazy(() => import("@/pages/ClientView"));
const ClientPortal = lazy(() => import("@/pages/ClientPortal"));
const SignContract = lazy(() => import("@/pages/SignContract"));
const InterviewPick = lazy(() => import("@/pages/InterviewPick"));
const MeetGuest = lazy(() => import("@/pages/MeetGuest"));
const UploadRequest = lazy(() => import("@/pages/UploadRequest"));
const SearchPage = lazy(() => import("@/pages/SearchPage"));
const PreferencesPage = lazy(() => import("@/pages/PreferencesPage"));
const DigestPrefsPage = lazy(() => import("@/pages/DigestPrefsPage"));
import { Analytics } from "@/components/site/Analytics";
import { HeatTracker } from "@/components/site/HeatTracker";
import { SeoGuard } from "@/components/site/SeoGuard";
import { LangRedirect } from "@/components/site/LangToggle";
const HomeHi = lazy(() => import("@/pages/HomeHi"));
const MarketPulseHi = lazy(() => import("@/pages/MarketPulseHi"));
const ViduraWidget = lazy(() => import("@/components/ViduraWidget").then((m) => ({ default: m.ViduraWidget })));
const ViduraFieldAssist = lazy(() => import("@/components/ViduraFieldAssist").then((m) => ({ default: m.ViduraFieldAssist })));
import { captureUtm } from "@/lib/utm";
import { SelfUnblock } from "@/components/site/SelfUnblock";
import { AfterIdle } from "@/components/site/LazyMount";
import { SessionCountdown } from "@/components/site/SessionCountdown";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => { captureUtm(); }, []);
  return null;
}

function AppRouter() {
  const location = useLocation();
  const [netBlocked, setNetBlocked] = useState(null);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/security/access-check`)
      .then(async (r) => {
        if (r.status === 403) {
          const d = await r.json().catch(() => ({}));
          setNetBlocked(typeof d.detail === "string" ? d.detail : "Access blocked by security policy.");
        } else if (r.ok) {
          const d = await r.json();
          if (d.allowed === false) setNetBlocked(d.reason || "Access blocked by security policy.");
        }
      }).catch(() => {});
  }, []);
  const staffGate = typeof window !== "undefined" && sessionStorage.getItem("gf_staff_login") === "1"
    && /^\/(teamportal|team-portal|hq|admin)/.test(location.pathname);
  if (netBlocked && !staffGate) {
    return (
      <div className="min-h-screen bg-gf-bg flex items-center justify-center p-6">
        <div className="max-w-md text-center" data-testid="access-blocked-screen">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-red-400">Access refused</p>
          <h1 className="font-heading font-black text-gf-text text-2xl mt-4">Growthifye Security Shield</h1>
          <p className="font-body text-sm text-gf-muted mt-4">{netBlocked}</p>
          {/suspicious activity/i.test(netBlocked) && <SelfUnblock />}
          <button
            data-testid="staff-signin-bypass-btn"
            onClick={() => { sessionStorage.setItem("gf_staff_login", "1"); window.location.href = window.gfPath("/teamportal"); }}
            className="mt-8 font-mono text-[10px] uppercase tracking-widest text-gf-muted border border-white/15 px-4 py-2 hover:text-gf-text hover:border-gf-primary transition-colors">
            Growthifye staff? Sign in
          </button>
        </div>
      </div>
    );
  }
  // Process OAuth return (session_id in URL fragment) before anything else.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const hideVidura = /^\/(teamportal|team-portal|hq|admin|meet\/|sign\/|interview\/|upload\/|client-view\/|supplier-portal\/|vendor-hub\/)/.test(location.pathname);
  return (
    <>
      <ScrollToTop />
      <SeoGuard />
      <LangRedirect />
      <Analytics />
      <HeatTracker />
      <AfterIdle>{!hideVidura && <ViduraWidget />}<ViduraFieldAssist /></AfterIdle>
      <SessionCountdown />
      <Suspense fallback={<div className="min-h-screen bg-gf-bg" data-testid="route-loading" />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hi" element={<HomeHi />} />
        <Route path="/market-prices" element={<MarketPricesPage />} />
        <Route path="/how-we-save" element={<HowWeSavePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/preferences" element={<PreferencesPage />} />
        <Route path="/digest-prefs" element={<DigestPrefsPage />} />
        <Route path="/careers" element={<LifePage />} />
        <Route path="/life-at-growthifye" element={<Navigate to="/careers" replace />} />
        <Route path="/contactus" element={<ContactPage />} />
        <Route path="/contact-us" element={<Navigate to="/contactus" replace />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/system-docs" element={<SystemDocsPage />} />
        <Route path="/besssizing" element={<BessSizing />} />
        <Route path="/compare/:token" element={<SharedCompare />} />
        <Route path="/vendor-quote/:token" element={<VendorQuotePage />} />
        <Route path="/vendor-clarify/:token" element={<VendorClarifyPage />} />
        <Route path="/verify-whatsapp" element={<VerifyWhatsAppPage />} />
        <Route path="/vault-upload/:token" element={<VaultUploadPage />} />
        <Route path="/broker-quote/:token" element={<BrokerQuotePage />} />
        <Route path="/matrix-signoff/:token" element={<MatrixSignoffPage />} />
        <Route path="/exit-survey/:token" element={<ExitSurveyPage />} />
        <Route path="/vendor-hub/:token" element={<VendorHubPage />} />
        <Route path="/supplier-portal/:token" element={<SupplierPortalPage />} />
        <Route path="/agreement-review/:token" element={<AgreementReviewPage />} />
        <Route path="/agreement-sign/:token" element={<AgreementSignPage />} />
        <Route path="/marketpulse" element={<MarketPulsePage />} />
        <Route path="/solutions/:tag" element={<SolutionPage />} />
        <Route path="/alerts" element={<AlertsManagePage />} />
        <Route path="/intel/oem/:slug" element={<OemProfilePage />} />
        <Route path="/intel/:topic" element={<IndustryIntelPage />} />
        <Route path="/intel" element={<Navigate to="/intel/bess" replace />} />
        <Route path="/market-pulse" element={<Navigate to={`/marketpulse${window.location.search}`} replace />} />
        <Route path="/hi/marketpulse" element={<MarketPulseHi />} />
        <Route path="/hi/market-pulse" element={<Navigate to="/hi/marketpulse" replace />} />
        <Route path="/bess-sizing" element={<Navigate to="/besssizing" replace />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/privacy-policy" element={<Navigate to="/privacypolicy" replace />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/termsandconditions" element={<Navigate to="/terms" replace />} />
        <Route path="/sitemap" element={<SitemapPage />} />
        <Route path="/tenders" element={<Tenders />} />
        <Route path="/l/:code" element={<LinkGate />} />
        <Route path="/audit/:token" element={<AuditPage />} />
        <Route path="/ebooks" element={<EbooksPage />} />
        <Route path="/tenders/:id" element={<TenderDetail />} />
        <Route path="/ppp/:slug" element={<StatePppPage />} />
        <Route path="/real-estate" element={<RealEstatePage />} />
        <Route path="/real-estate/:city" element={<RealEstateCityPage />} />
        <Route path="/ppp-intel" element={<PppIntelPage />} />
        <Route path="/infra-intel" element={<InfraIntelPage />} />
        <Route path="/regulatory" element={<RegulatoryNavigatorPage />} />
        <Route path="/regulatory/:code" element={<RegulatoryNavigatorPage />} />
        <Route path="/nexus" element={<SaasSuitePage />} />
        <Route path="/nexus/:group" element={<NexusModulePage />} />
        <Route path="/saas" element={<Navigate to="/nexus" replace />} />
        <Route path="/energy-map" element={<EnergyGridMapPage />} />
        <Route path="/intel/transmission" element={<TransmissionIntelPage />} />
        <Route path="/tariffs" element={<TariffsPage />} />
        <Route path="/intel/mod-sced" element={<ModScedPage />} />
        <Route path="/intel/auction-tariffs" element={<AuctionTariffsPage />} />
        <Route path="/markets/auction-tariffs" element={<AuctionTariffsPage />} />
        <Route path="/markets/pm-kusum" element={<MarketsKusumPage />} />
        <Route path="/markets/solar-pumps" element={<MarketsSolarPumpsPage />} />
        <Route path="/markets/rpo" element={<MarketsRpoPage />} />
        <Route path="/ea/:token" element={<EAuctionBidPage />} />
        <Route path="/tariffs/orders/:state" element={<TariffOrdersPage />} />
        <Route path="/tariffs/orders/:state/:id" element={<TariffOrdersPage />} />
        <Route path="/coreservices/:slug/approach/:step" element={<ApproachStepPage />} />
        <Route path="/podcast" element={<PodcastPage />} />
        <Route path="/podcast/:slug" element={<PodcastPage />} />
        <Route path="/hi/podcast/:slug" element={<PodcastPage />} />
        <Route path="/landmarks/:service/:slug" element={<LandmarkLessonPage />} />
        <Route path="/nmp" element={<NmpPage />} />
        <Route path="/nmp/:sector" element={<NmpPage />} />
        <Route path="/nmp/:sector/case-study" element={<NmpCaseStudyPage />} />
        <Route path="/state/:slug" element={<StatePage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/casestudies" element={<CaseStudiesPage />} />
        <Route path="/case-studies" element={<Navigate to="/casestudies" replace />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/impact" element={<ImpactPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/digest" element={<DigestArchivePage />} />
        <Route path="/archive" element={<ArchivePage />} />
        <Route path="/topics/:topic" element={<TopicPage />} />
        <Route path="/insights/:slug" element={<InsightPost />} />
        <Route path="/hi/insights/:slug" element={<InsightPost />} />
        <Route path="/client-view/:token" element={<ClientView />} />
        <Route path="/clientportal" element={<ClientPortal />} />
        <Route path="/sign/:token" element={<SignContract />} />
        <Route path="/interview/:token" element={<InterviewPick />} />
        <Route path="/meet/:id" element={<MeetGuest />} />
        <Route path="/upload/:token" element={<UploadRequest />} />
        <Route path="/client-login" element={<Navigate to="/clientportal" replace />} />
        <Route path="/client-portal" element={<Navigate to="/clientportal" replace />} />
        <Route path="/teamportal" element={<TeamPortal />} />
        <Route path="/tender/:tid" element={<TenderPage />} />
        <Route path="/team-portal" element={<Navigate to="/teamportal" replace />} />
        <Route path="/hq" element={<Navigate to="/teamportal" replace />} />
        <Route path="/aboutus" element={<ApproachIndex />} />
        <Route path="/aboutus/:slug" element={<ApproachPage />} />
        <Route path="/approach" element={<Navigate to="/aboutus" replace />} />
        <Route path="/approach/:slug" element={<LegacyApproachRedirect />} />
        <Route path="/coreservices" element={<ServicesIndex />} />
        <Route path="/coreservices/:slug/:capability" element={<AdvisoryCapabilityPage />} />
        <Route path="/coreservices/:slug" element={<ServicePage />} />
        <Route path="/hi/coreservices/:slug" element={<ServicePageHi />} />
        <Route path="/services" element={<Navigate to="/coreservices" replace />} />
        <Route path="/services/:slug/:capability" element={<LegacyServiceRedirect />} />
        <Route path="/services/:slug" element={<LegacyServiceRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Suspense>
    </>
  );
}

function App() {
  return (
    <div className="App gf-grain font-body">
      <BrowserRouter basename={window.__gfBasename || ""}>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" theme="dark" />
          <CookieConsent />
          <BookmarkVisitTracker />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
